<template>
  <div v-if="headers && headers !== []">
    <v-card>
      <template v-slot:after-heading>
        <div
          v-if="metadata.form && metadata.form.title"
          class="text-h3 font-weight-light"
        >
          {{ metadata.form.title }}
        </div>
      </template>
      <v-data-table
        :headers="headers.filter(a=>a.show || a.active)"
        :items="items"
        multi-sort
        :server-items-length="total"
        :options.sync="table_options"
        :loading="loading"
        :footer-props="datatable_footer"
        no-data-text="Нет данных для отображения"
      >
        <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
          {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row dense>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="form.search"
                    clearable
                    outlined
                    label="Поиск"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-btn
                    color="primary"
                    outlined
                    @click="filter_dialog = true;"
                  >
                    <v-icon class="ml-3">
                      mdi-filter-variant
                    </v-icon>
                    <span class="mx-3">ФИЛЬТРЫ</span>
                  </v-btn>
                </v-col>
                <v-col
                  v-if="entity==='sbp' || 'task'"
                  cols="12"
                  md="2"
                >
                  <timezone-picker v-model="timeZone" />
                </v-col>

                <v-col
                  cols="12"
                  class="text-right d-none d-md-block"
                  md="5"
                >
                  <v-btn
                    v-if="metadata.create"
                    color="primary"
                    @click="$router.push(path + '/create')"
                  >
                    <v-icon class="ml-3">
                      mdi-plus
                    </v-icon>
                    <span class="mx-3">Добавить</span>
                  </v-btn>
                  <v-btn
                    color="secondary"
                    outlined
                    class="ml-5"
                    @click="report"
                  >
                    <v-icon class="ml-3">
                      mdi-download
                    </v-icon>
                    <span class="mx-3">Выгрузить</span>
                  </v-btn>
                  <v-btn
                    v-if="metadata.import"
                    color="secondary"
                    outlined
                    class="ml-5"
                    @click="showImport"
                  >
                    <v-icon class="ml-3">
                      mdi-import
                    </v-icon>
                    <span class="mx-3">Импорт</span>
                  </v-btn>
                  <v-icon
                    medium
                    class="icon-table"
                    @click="show_header_dialog"
                  >
                    mdi-table-cog
                  </v-icon>
                </v-col>
                <v-col
                  cols="12"
                  class="d-md-none"
                >
                  <v-btn
                    v-if="metadata.create"
                    color="primary"
                    @click="$router.push(path + '/create')"
                  >
                    <v-icon class="ml-3">
                      mdi-plus
                    </v-icon>
                    <span class="mx-3">Добавить</span>
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  class="d-md-none"
                >
                  <v-btn
                    color="secondary"
                    outlined
                    @click="report"
                  >
                    <v-icon class="ml-3">
                      mdi-download
                    </v-icon>
                    <span class="mx-3">Выгрузить</span>
                  </v-btn>
                </v-col>
                <!-- Icon -->
                <v-col
                  cols="12"
                  class="d-md-none"
                >
                  <v-icon
                    medium
                    class="icon-table"
                    @click="show_header_dialog"
                  >
                    mdi-table-cog
                  </v-icon>
                </v-col>
                <v-col
                  cols="12"
                  class="mt-n5"
                >
                  <div v-if="filter.set">
                    <div
                      v-for="(tab, index) in filter_fields"
                      :key="'tab_f' + index"
                    >
                      <v-chip
                        v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to)"
                        :key="'data_f' + index2"
                        color="grey lighten-2"
                        class="ma-1"
                        close
                        @click:close="clear_filter_value(filter)"
                      >
                        <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                        <span v-else-if="filter.type == 'select' || filter.type == 'autocomplete'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                        <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                      </v-chip>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item="{item, headers}">
          <tr>
            <td v-if="headers.find(f=>f.text==='Просмотр') !== undefined">
              <v-menu
                bottom
                left
              >
                <template v-slot:activator="{ on, attrs}">
                  <v-btn
                    v-bind="attrs"
                    color="primary"
                    text
                    v-on="on"
                    @click="onViewConfiguration(item)"
                  >
                    <v-icon

                      class="beg_triangle"
                    >
                      mdi-open-in-new
                    </v-icon>
                  </v-btn>
                </template>
              </v-menu>
            </td>
            <!--            -->
            <td>
              <v-menu
                :close-on-content-click="true"
                :nudge-width="100"
                :nudge-bottom="12"
                offset-y
              >
                <template v-slot:activator="{ on, attrs, value }">
                  <v-btn
                    v-bind="attrs"
                    color="primary"
                    text
                    v-on="on"
                    @click="sheetitem = item"
                  >
                    <v-icon
                      large
                      class="beg_triangle"
                    >
                      mdi-menu-open
                    </v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item
                      v-if="!sheetitem.deleted"
                      @click="$router.push(path + '/view?id=' + sheetitem.id)"
                    >
                      <v-list-item-content>
                        Открыть
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="!sheetitem.deleted"
                      @click="DeleteItem(sheetitem)"
                    >
                      <v-list-item-content>
                        Удалить
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="sheetitem.deleted"
                      @click="RestoreItem(sheetitem)"
                    >
                      <v-list-item-content>
                        Восстановить
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="entity == 'sbp'"
                      @click="ReturnItem(sheetitem)"
                    >
                      <v-list-item-content>
                        Вернуть
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </td>
            <td
              v-for="(row, index_row) in metadata.table"
              v-if="headers.filter(a=>a.value==row.key)[0] && headers.filter(a=>a.value==row.key)[0].active == true"
              :key="item.id + 'header'+ index_row"
            >
              <div>
                <div v-if="row.type == 0">
                  {{ get_value(item, row.key) }}
                </div>
                <div v-if="row.type == 1">
                  {{ item[row.key] }}
                </div>
                <div v-if="row.type == 2">
                  {{ format_time(item[row.key]) }} <!--todo: date moment-->
                </div>
                <div v-if="(row.type == 3 || row.type == 7) && row.select && row.select.filter(a=>a.value === item[row.key])[0]">
                  <v-chip :color="row.select.filter(a=>a.value === item[row.key])[0].color">
                    {{ row.select.filter(a=>a.value === item[row.key])[0].text }}
                  </v-chip>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog
        v-model="filter_dialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs
              v-model="tab_index"
              v-resize="onResizeWindow"
              :vertical="verticalTabs"
            >
              <v-tab
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <div class="filter_row">
                  {{ tab.name }}
                  <v-btn
                    icon
                    @click="setFavouriteTab(tab.index)"
                  >
                    <v-icon
                      left
                      :class="[{'active': $store.state.user.tab_client == tab.index}]"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </div>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filter_fields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="changeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="max_date"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-autocomplete
                        v-else-if="field.type=='autocomplete'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        hint="Введите символы для поиска"
                        @change="filter.changed = true"
                      />
                      <v-text-field
                        v-else
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              outlined
              rounded
              small
              @click="filter_dialog = false, clear_filter()"
            >
              <span class="mx-10">Сбросить</span>
            </v-btn>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="filter_dialog = false, set_filter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="filter_dialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, set_headers()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <v-dialog
        v-model="dialog.import.show"
        persistent
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Импорт</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="dialog.import.client"
                  clearable
                  :filter="client_filter"
                  :items="select.clients"
                  item-value="id"
                  label="Наименование клиента"
                  :loading="search.client.loading"
                  :search-input.sync="search.client.text"
                  hide-no-data
                  hint="Введите минимум три символа для поиска"
                >
                  <template v-slot:selection="{item}">
                    <v-list>
                      <v-list-item-content>
                        <v-list-item-title> {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list two-line>
                      <v-list-item-content>
                        <v-list-item-title>  {{ item.legal.name.short || item.legal.name.full }}</v-list-item-title>
                        <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="8">
                <v-select
                  v-model="dialog.import.type"
                  :items="dialog.import.types.filter(a=>a.client == dialog.import.client)"
                  item-text="description"
                  item-value="id"
                  label="Интеграция"
                />
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="primary"
                  class="ml-2 mb-2 btn-hi-secondary"
                  @click="loadImportData()"
                >
                  <span class="mx-10">Получить</span>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  label="Загрузить файл"
                  @change="loadImportDataFile"
                />
              </v-col>
              <v-col cols="12">
                <v-data-table
                  v-model="dialog.import.selected"
                  show-select
                  :items="dialog.import.data"
                  item-key="code"
                  :headers="[
                    {
                      value: 'name',
                      text: 'Назание'
                    },
                    {
                      value: 'code',
                      text: 'Артикул'
                    },
                    {
                      value: 'code_ext',
                      text: 'Внешний идентификатор'
                    },
                    {
                      value: 'product_uuid',
                      text: 'Идентификатор продукта'
                    },
                    {
                      value: 'plu',
                      text: 'Код поиска цены'
                    },
                    {
                      value: 'tax',
                      text: 'Ставка НДС'
                    },
                    {
                      value: 'type',
                      text: 'Тип номенклатуры'
                    },
                    {
                      value: 'unit',
                      text: 'Единица измерения'
                    },
                    {
                      value: 'price',
                      text: 'Цена'
                    }
                  ]"
                  :footer-props="datatable_footer"
                  no-data-text="Нет данных для отображения"
                >
                  <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                    {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                  </template>
                  <template v-slot:item.name="{item}">
                    <v-text-field
                      v-model="item.name"
                    />
                  </template>
                  <template v-slot:item.code="{item}">
                    <v-text-field
                      v-model="item.code"
                    />
                  </template>
                  <template v-slot:item.code_ext="{item}">
                    <v-text-field
                      v-model="item.code_ext"
                    />
                  </template>
                  <template v-slot:item.product_uuid="{item}">
                    <v-text-field
                      v-model="item.product_uuid"
                    />
                  </template>
                  <template v-slot:item.unit="{item}">
                    <v-select
                      v-model="item.unit"
                      :items="GetDictItems($store.state.dict.unit_type)"
                    />
                  </template>
                  <template v-slot:item.tax="{item}">
                    <v-select
                      v-model="item.tax"
                      :items="select.tax"
                    />
                  </template>
                  <template v-slot:item.type="{item}">
                    <v-select
                      v-model="item.type"
                      :items="select.type"
                    />
                  </template>
                  <template v-slot:item.plu="{item}">
                    <v-text-field
                      v-model="item.plu"
                    />
                  </template>
                  <template v-slot:item.price="{item}">
                    <v-text-field
                      v-model="item.price"
                      type="number"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="120"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.import.show = false, doImport()"
            >
              <span class="mx-10">Импортировать</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.import.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style lang="scss">
/* client-list copy */
.icon-filter {
  color: grey;
  &.active {
    color:orange;
  }
  &:not(.active):hover {
    color: #21A038;
  }
}
.icon-magnify {
  color: rgb(121, 114, 118);
  &:hover {
    color: #21A038;
  }
}
.icon-table {
  height: 30px;
  width: 30px;
  margin-top: 3px;
  margin-left: 8px;
  color: grey;
  &:hover {
    color: #21A038;
  }
}
.btns-edit-group {
  height: 36px!important;
  .beg_pencil {
    background-color: rgb(0, 143, 203)!important;
    border-color: rgb(24, 123, 154)!important;
    color: white;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    min-width: 50px!important;
    width: 50px!important;
    height: 36px!important;
  }
  .beg_select {
    background-color: rgb(0, 143, 203)!important;
    border-color: rgb(24, 123, 154)!important;
    color: white;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    min-width: 30px!important;
    width: 30px!important;
    height: 36px!important;

    .beg_triangle {
      transform: scale(0.36,0.22) rotate(180deg);
    }
    &.active {
      .beg_triangle {
        transform: scale(0.36,0.22) rotate(0deg);
      }
    }
  }
  .v-btn__content,
  i {
    height: 36px!important;
  }
}
/**popup */
.filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
  display: flex;
  flex-direction: column;
  height: 80px;
  width: 140px;
  font-size: 0.6rem !important;
  line-height: 0.8rem;
  white-space: pre-wrap;
  .filter_row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .v-btn {
      height: 30px;
      width: 30px;
      margin-right: -15px;
      &:hover {
        .v-icon {
          color: rgba(0, 0, 0, 0.1);
        }
      }
      .v-icon {
        margin: 0px;
        color: rgba(0, 0, 0, 0.01);
        &.active {
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
@media (min-width: 960px) {
  .filter_popup .v-tabs--vertical > .v-tabs-bar .v-tab {
    flex-direction: row;
    height: 54px;
    width: 180px;
    font-size: 0.70rem !important;
    line-height: 0.8rem;
    white-space: pre-wrap;
    .filter_row {
      .v-btn {
        margin-left: 10px;
      }
    }
  }
}
/** _popup */

.search-row {
  display: flex;
  flex-direction: row;
}
.search-title {
  padding-top: 24px;
  padding-right: 10px;
  margin-top: 4px;
  font-size: 1.6rem;
  color: #ec7e2f;
}
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle {
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}

</style>
<script>
import moment from "moment"
import $ from "jquery"
import suggest from "../../../libs/suggestions.min.17.12.0.dev.js"
import { setTimeout } from 'timers'
import TimezonePicker from "@/views/loyalty/shared/components/timezone-picker/TimezonePicker.vue"
import { utcToZonedTime } from "date-fns-tz"
export default {
  components: { TimezonePicker },
  props: {
    entity: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    table_options: {

    },
    total: 10,
    loading: false,
    tab_index: 0,
    items: [],
    metadata: {
      decline: true
    },
    search: {
      client: {
        loading: false,
        text: ''
      }
    },
    datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
    form: {
    },
    headers: [
       {}
    ],
    filter: {
    },
    select: {
        clients: [],
        tax: [
          { value: 1, text: 'НДС 20%' },
          { value: 2, text: 'НДС 10%' },
          { value: 3, text: 'НДС по расч. ставке 20/120' },
          { value: 4, text: 'НДС по расч. ставке 10/110' },
          { value: 5, text: 'НДС 0%' },
          { value: 6, text: 'НДС не облагается' },
          { value: 7, text: 'НДС 5%' },
          { value: 8, text: 'НДС 7%' },
          { value: 9, text: 'НДС по расч. ставке 5/105' },
          { value: 10, text: 'НДС по расч. ставке 7/107' },
        ],
        type: [
          { value: 1, text: "Товар " },
          { value: 2, text: "Подакцизный товар " },
          { value: 3, text: "Работа " },
          { value: 4, text: "Услуга " },
          { value: 5, text: "Ставка азартной игры " },
          { value: 6, text: "Выигрыш азартной игры " },
          { value: 7, text: "Лотерейный билет " },
          { value: 8, text: "Выигрыш лотереи " },
          { value: 9, text: "Предоставление РИД " },
          { value: 10, text: "Платеж " },
          { value: 11, text: "Агентское вознаграждение " },
          { value: 12, text: "Выплата " },
          { value: 13, text: "Иной предмет расчета " },
          { value: 14, text: "Имущественное право " },
          { value: 15, text: "Внереализационный доход* " },
          { value: 16, text: "Иныеплатежи ивзносы* " },
          { value: 17, text: "Торговыйсбор " },
          { value: 18, text: "Курортныйсбор " },
          { value: 19, text: "Залог " },
          { value: 20, text: "Расход " },
          { value: 21, text: "Взносы наобязательноепенсионное страхование ИП " },
          { value: 22, text: "Взносы" }
        ],
    },
    sheetitem: {},
    filter_dialog: false,
    dialog: {
        headers: {
          show: false
        },
        import: {
          show: false,
          data: [],
          type: null,
          types: [],
          selected: [],
          client: null
        }
      },
temp_filter_fields: {
  common: {
    index: 0,
    name: 'Основное',
    active: true,
    data: [
      {
        name: 'Номер',
        data: 'number',
        type: 'text',
      },
      {
        name: 'Дата создания',
        data: 'created',
        type: 'date',
      },
      {
        name: 'Наименование компании (полное)',
        data: 'legal.name.full',
        type: 'text',
      },
      {
        name: 'Наименование компании (сокращенное)',
        data: 'legal.name.short',
        type: 'text',
      },
      {
        name: 'Торговая марка',
        data: 'name',
        type: 'text',
      },
    ],
  },
  legal_data: {
    index: 1,
    name: 'Компания',
    active: true,
    data: [
      {
        name: 'ИНН',
        data: 'legal.inn',
        type: 'text'
      },
      {
        name: 'КПП',
        data: 'legal.kpp',
        type: 'text'
      },
      {
        name: 'Телефон',
        data: 'phones.number',
        type: 'text'
      },
      {
        name: 'Адрес',
        data: 'addresses.value',
        type: 'text'
      },
      {
        name: 'ФИО руководителя',
        data: 'legal.director.name',
        type: 'text'
      }
    ],
  },
},
    filter_fields: {
    },
    timeZone: '',
    verticalTabs: true,
  }),
  computed: {},
  watch: {
    'search.client.text': function () {
      if (this.search.client.text) { this.load_clients(this.search.client.text) }
    },
    '$route.params.entity': function () {
      this.load_metadata()
    },
    table_options: {
      handler () {
        console.log(this.table_options)
        this.$router.push({
            query: {
              page: this.table_options.page,
              limit: this.table_options.itemsPerPage
            }
          })
        this.load()
      },
      deep: true,
    },
    timeZone: {
      handler () {
        this.items = this.getItemsWithTZ(this.items)
      }
    },
  },
  mounted: function () {
    this.load_metadata()
    if (false) {

    } else {
        const filter = localStorage.getItem(this.entity)
        if (filter) {
          this.filter_fields = JSON.parse(filter)
          this.filter.set = true
          this.filter.changed = false
        }
      }
      if (this.$route.query.page) {
        this.table_options.page = Number(this.$route.query.page)
        this.table_options.itemsPerPage = Number(this.$route.query.limit)
      }
  },
  beforeRouteEnter (to, from, next) {
      next()
    },
  methods: {
    GetDictItems (dict) {
      const select = []
      for (const x in dict) {
        select.push({
          value: Number(x),
          text: dict[x].name
        })
      }
      return select
    },
    get_value (item, key) {
      if (key && item) {
        if (key.indexOf('.') == -1) return item[key]
        else {
          return this.get_value(item[key.substring(0, key.indexOf('.'))], key.substring(key.indexOf('.') + 1))
        }
      }
      return ''
    },
    showImport () {
      this.axios.post('/api/integration/list', {})
        .then(response => {
          if (!response.data.error) {
            this.dialog.import.types = response.data.data
            this.dialog.import.show = true
            this.load_clients()
          }
        })
    },
    loadImportData () {
      this.axios.post('/api/integration/nomenclature/list', {
        id: this.dialog.import.type,
        client: this.dialog.import.client
      })
        .then(response => {
          if (!response.data.error) {
            this.dialog.import.data = response.data.data
          }
        })
    },
    loadImportDataFile (file) {
      console.log(file)
      if (!file) return
          const data = new FormData()
          data.append("file", file)
          this.$axios
            .post("/api/common/file/", data, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(response => {
              this.axios.post('/api/integration/nomenclature/list', {
                file: response.data.data[0].id
              })
                .then(response => {
                  if (!response.data.error) {
                    this.dialog.import.data = response.data.data
                  }
                })
            })
            .catch(error => {

            })
    },
    doImport () {
      for (const x in this.dialog.import.selected) {
        const item = this.dialog.import.data.filter(a => a.code == this.dialog.import.selected[x].code)[0]
        item.client = this.dialog.import.client
        this.axios.post('/api/nomenclature/create', item).then(a => {

        })
      }
     const self = this
     setTimeout(() => {
        self.dialog.import.show = false
        self.load()
     }, 1000)
    },
    load_metadata () {
      this.axios.post('/api/' + this.entity + '/metadata', {})
        .then(result => {
          this.form.id = null
          if (!result.data.error) {
            this.metadata = result.data.data
            if (this.entity === 'sbp' || this.entity === 'task') {
              this.metadata.table = this.getMetadataWithTZ(this.metadata.table)
              console.log('metadata', this.metadata)
            }
            this.headers = []
            this.init()
          }
        })
        .catch(e => {
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
    },
    client_filter: function (item, query, text) {
      if (query) return true
      if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
      return false
    },
    DeleteItem: function (item) {
      if (confirm('Вы уверены?')) {
        item.deleted = true
        this.axios.post('/api/' + this.entity + '/save', item)
          .then(result => {
            this.loading = false
            if (!result.data.error) {
              this.$store.commit('snackbar', 'Удаление успешно')
              this.load()
            } else {
              this.$store.commit('snackbar', 'Ошибка при удалении')
            }
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('snackbar', 'Ошибка при удалении')
          })
      }
    },
    ReturnItem: function (item) {
      if (confirm('Вы уверены?')) {
        this.axios.post('/api/' + this.entity + '/decline/' + item.id, {})
          .then(result => {
            this.loading = false
            if (!result.data.error) {
              this.$store.commit('snackbar', result.data.data)
            } else {
              this.$store.commit('snackbar', result.data.data)
            }
            this.load()
          })
          .catch(error => {
            this.loading = false
            this.$store.commit('snackbar', 'Ошибка при удалении')
          })
      }
    },
    load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
    load_clients_id: function (id) {
      if (!id) return
      this.axios.post('/api/client/list', {
        id: id
      })
      .then(result => {
        this.search.client.loading = false
        if (!result.data.error) {
          this.select.clients = result.data.data
        }
      })
      .catch(e => {
        console.log(e)
        this.search.client.loading = false
      })
    },
    init: function () {
      const entity = ['admin.client',
      'admin.configuration',
      'admin.device',
      'admin.member',
      'admin.equipment',
      'admin.event',
      'admin.fiscal',
      'admin.item',
      'admin.kkt',
      'admin.operator',
      'admin.place',
      'admin.point',
      'admin.role',
      'admin.user',
      'admin.sbpbank',
      'admin.sbpprofile',
      'admin.nomenclature',
      'admin.category',
      'admin.order',
      'admin.payment',
      'client.configuration',
      'client.device',
      'client.member',
      'client.equipment',
      'client.event',
      'client.fiscal',
      'client.item',
      'client.kkt',
      'client.operator',
      'client.place',
      'client.point',
      'client.role',
      'client.user',
      'client.sbpbank',
      'client.sbpprofile',
      'client.nomenclature',
      'client.category',
      'client.order',
      'client.payment']
      for (const x in entity) {
        if (entity[x] != this.entity) {
          localStorage.removeItem(entity[x])
        }
      }
      if (this.$route.query.page) {
        this.table_options.page = Number(this.$route.query.page)
        this.table_options.itemsPerPage = Number(this.$route.query.limit)
      }
      if (this.metadata.table) {
        if (this.metadata.form.title === 'Задачи') {
          this.headers = [{ text: 'Просмотр', show: true }, { text: 'Действия', show: true }]
        } else {
          this.headers = [{ text: 'Действия', show: true }]
        }
        for (const headers_pos in this.metadata.table) {
          if (!this.headers[this.metadata.table[headers_pos].key]) {
            this.headers.push(
              {
                value: this.metadata.table[headers_pos].key,
                text: this.metadata.table[headers_pos].title,
                active: true
              })
          }
        }
      }
      console.log('this.headers', this.headers)
      if (this.metadata && this.metadata.form && this.metadata.form.tabs) {
        for (const tab_pos in this.metadata.form.tabs) {
          const tab_data = []
          for (const row_pos in this.metadata.form.tabs[tab_pos].rows) {
            for (const field_pos in this.metadata.form.tabs[tab_pos].rows[row_pos].fields) {
              if (this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos].filter) { // Проверить filter
                tab_data.push({
                  ...this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos],
                  name: this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos].title,
                  data: this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos].key,
                  type_id: this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos].type,
                  type: this.textType(this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos].type),
                  select: this.metadata.form.tabs[tab_pos].rows[row_pos].fields[field_pos].select
                })
              }
            }
          }
          if (tab_data && tab_data.length > 0) {
            this.$set(
              this.filter_fields,
              tab_pos, // this.metadata.form.tabs[tab_pos].key
              (
                {
                  index: tab_pos,
                  name: this.metadata.form.tabs[tab_pos].title,
                  active: true,
                  data: tab_data
                }
              )
            )
          }
        }
      }
      this.load()
      this.set_default_headers()
    },
    textType (type) {
      switch (type) {
        case 0:
          return 'text' // Text
        case 1:
          return 'text' // Numeric
        case 2:
          return 'date' // Date
        case 3:
          return 'select' // Select
        case 4:
          return 'text' // Checkbox
        case 5:
          return 'text' // PictureUpload
        case 7:
          return 'autocomplete' // Autocomplete
        default:
          return 'text'
      }
    },
    load () {
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        if (this.entity === 'task') {
          request.data[0].data = request.data[0].data.map(m => {
            if (Object.hasOwn(m, 'value')) {
              if (m.data === "point" && typeof m.value === 'object') {
                m.data = "point._id" // set "point._id" instead "point", because "_id" is nested field
                m.value = m.value.id
              }
            }
            return m
          })
        }
        delete request.data.set
        delete request.data.changed
      }
      console.log('this.entity', this.entity)
        console.log('request', request)
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
      request.page = page
      request.limit = itemsPerPage
      this.axios.post('/api/' + this.entity + '/list', request)
        .then(result => {
          this.loading = false
          this.form.id = null
          if (!result.data.error) {
            this.items = result.data.data
            this.total = Number(result.data.count)
            if (this.entity === 'sbp' || this.entity === 'task') {
              this.items = this.getItemsWithTZ(this.items)
              console.log('sbp items', this.items)
            }
            console.log(this.total)
          }
        })
        .catch(e => {
          this.loading = false
          console.log(e)
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
    },
    get_src: function (id) {
      return "/api/common/file?id=" + id
    },
    upload: function () {
      if (this.file) {
        const data = new FormData()
        data.append("file", this.file)
        this.axios
          .post("/api/common/file", data, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            if (response.data.error) {
              this.$store.commit("snackbar", "Ошибка при сохранении данных")
            } else {
              this.form.icon = response.data.data[0]
            }
          })
          .catch(error => {
            this.$store.commit("snackbar", "Ошибка при сохранении данных")
          })
      }
    },
    report: function () {
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        delete request.data.set
        delete request.data.changed
      }
      request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
      const form = $('<form>', {
        target: '_blank',
        action: '/api/' + this.entity + '/export?token=' + localStorage.getItem('token'),
        method: 'post',
      })
      form.append(
        $('<input>', {
          type: 'hidden',
          value: JSON.stringify(request),
          name: 'form',
        })
      )
      form.appendTo('body').submit()
    },
    show_header_dialog: function () {
        for (const x in this.headers) {
          this.headers[x].active_temp = this.headers[x].active
        }
        this.dialog.headers.show = true
      },
      set_headers: function () {
        for (const x in this.headers) {
          this.headers[x].active = this.headers[x].active_temp
        }
        this.$axios.post('/api/user/headers', {
          entity: this.entity,
          headers: this.headers.filter(a => a.active).map(a => a.value)
        })
        .catch(e => {
          console.log(e)
        })
      },
      set_default_headers: function () {
          if (!this.$store.state.user[this.entity + '_headers'] || this.$store.state.user[this.entity + '_headers'].length == 0) return
          for (const x in this.headers) {
            this.headers[x].active = this.$store.state.user[this.entity + '_headers'].indexOf(this.headers[x].value) > -1
          }
      },
    set_filter: function (flag) {
        if (this.filter.changed) this.filter.set = true
        this.filter.changed = false
        this.load()
        localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
      },
      clear_filter: function () {
        this.filter.set = false
        for (const x in this.filter_fields) {
          for (const y in this.filter_fields[x].data) {
             this.filter_fields[x].data[y].value = ''
             this.filter_fields[x].data[y].from = ''
             this.filter_fields[x].data[y].to = ''
          }
        }
        localStorage.removeItem(this.entity)
      },
    clear_filter_value: function (field) {
      field.value = ''
      field.from = ''
      field.to = ''
      field.date_select = ''
      this.filter.changed = true
      this.set_filter()
    },
    formatInputDate: function (_date) {
      const date = new Date(_date)
      let dd = date.getDate()
      if (dd < 10) dd = '0' + dd

      let mm = date.getMonth() + 1
      if (mm < 10) mm = '0' + mm

      let yyyy = date.getFullYear()
      if (yyyy < 10) yyyy = '0' + yyyy

      return yyyy + '-' + mm + '-' + dd
    },
    changeFilterDateType (value, tab, field) {
      this.filter.changed = true
      console.log('changeFilterDateType', value, tab, field)
      if (tab && field && value) {
        if (value !== 'period' && value !== 'date') {
          let date = 0
          if (value == 'today') {
            date = new Date()
          } else if (value == 'yesterday') {
            date = new Date().setDate(new Date().getDate() - 1)
          } else if (value == 'tomorrow') {
            date = new Date().setDate(new Date().getDate() + 1)
          }
          const formated_date = this.formatInputDate(date)
          field.from = formated_date
          field.to = formated_date
        }
        if (value == 'date') {
          field.to = ''
        }
      }
    },
    format: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    format_time: function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    getItemsWithTZ (items) {
      items = items.map(item => {
        item.createdTZ = utcToZonedTime(item.created, this.timeZone)
        if (Object.hasOwn(item, 'updated')) {
          item.updatedTZ = utcToZonedTime(item.updated, this.timeZone)
        }
        return item
      })
      return items
    },
    getMetadataWithTZ (items) {
      items = items.map(item => {
        if (item.key === 'created') {
          item.key = 'createdTZ'
          item.key1 = 'createdTZ'
        }
        if (item.key === 'updated') {
          item.key = 'updatedTZ'
          item.key1 = 'updatedTZ'
        }
        return item
      })
      return items
    },
    onResizeWindow () {
      this.verticalTabs = window.innerWidth > 600
    },
    onViewConfiguration (item) {
      const routeData = this.$router.resolve({ path: 'view', query: { id: item.id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
